import { render } from "./PatientRegistrationView.vue?vue&type=template&id=c64516dc&scoped=true"
import script from "./PatientRegistrationView.vue?vue&type=script&lang=js"
export * from "./PatientRegistrationView.vue?vue&type=script&lang=js"

import "./PatientRegistrationView.vue?vue&type=style&index=0&id=c64516dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c64516dc"]])

export default __exports__